type FormNavDirection = "next" | "previous";

/**
 * Mirrors WebApp's "form nav clicked" Segment event
 * Keeps the step-completion funnel comparable once WebApp is retired.
 */
const trackFormNavClicked = (direction: FormNavDirection): void => {
  const pageName = window.location.pathname.replace(/^\//, "");

  analyticsIntegrations.trackEvent("form nav clicked", {
    category: "Host",
    direction,
    label: `${pageName}-${direction}`,
    "page name": pageName,
  });
};

export { trackFormNavClicked };
